import resolveArrayValue from 'css-in-js-utils/lib/resolveArrayValue';
import isPlainObject from 'isobject';

function resolveFallbackValues(style) {
  for (var property in style) {
    var value = style[property];

    if (Array.isArray(value)) {
      style[property] = resolveArrayValue(property, value);
    } else if (isPlainObject(value) && property !== 'fontFace') {
      style[property] = resolveFallbackValues(value);
    }
  }

  return style;
}

resolveFallbackValues.optimized = function (props) {
  if (Array.isArray(props.value)) {
    props.value = resolveArrayValue(props.property, props.value);
  }

  return props;
};

export default (function () {
  return resolveFallbackValues;
});